import { request } from "../network/request";
const dn0 = "dn0";
const dnomp = "dnomp";

/**
 *  指标导入
 * @param {*} data 
 * @returns 
 */
export function zbUpload(data) {
    return request({
        url: "zkgl/import/upload",
        method: "post",
        data
    });
}
//	指标最佳模型节点绑定查询
export function getZjmxbdList(data) {
    return request({
        url: "codereq/zkgl_zbgz_jdbdcx",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
//	指标复核审批人管理查询
export function getZbfhrList(data) {
    return request({
        url: "codereq/zkgl_zbgz_sprcx",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
//指标规则设置复核超时&风向预警(风险预警设置)
export function getFxyjData(data) {
    return request({
        url: "codereq/zkgl_zbgz_fhfx",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
//获取用户列表信息
export function getYgList(data) {
    return request({
        url: "codereq/zkgl_public_ygxxSelect",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
// 指标规则风险预警设置保存
export function saveFxyj(data) {
    return request({
        url: "pmp/zkgl/zbgz/savefxyj",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
// 指标最佳模型节点绑定&审批人更新保存
export function saveZbgz(data) {
    return request({
        url: "pmp/zkgl/zbgz/zbgzSave",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
//指标规则复核超时保存
export function saveFhcs(data) {
    return request({
        url: "pmp/zkgl/zbgz/savefhcs",
        method: "post",
        params: { ...data, db: dn0 }
    });
}

// 计划列表
export function getPlanList(data) {
    return request({
        url: "codereq/zkgl_xmzk_getXmjhList",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
//初始化展示字段列表
export function getZszdList(data) {
    return request({
        url: "pmp/zkgl/getZszdList",
        method: "post",
        params: { ...data, db: dn0 }
    });
}
//保存展示字段列表
export function saveZszd(data) {
    return request({
        url: "pmp/zkgl/saveZszd",
        method: "post",
        params: { ...data, db: dn0 }
    });
}

//部门项目树
export function getXmList(data) {
    return request({
        url: "pmp/zkgl/querybmxms",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
// 质控结果列表
export function getZkjgList(data) {
    return request({
        url: "pmp/zkgl/getZkjgList",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
//编辑结果
export function updateZkjg(data) {
    return request({
        url: "pmp/zkgl/updateZkjg",
        method: "post",
        data: { ...data, db: dn0 }
    });
}
//质控报表导出
export function exportZkjgList(data) {
    return request({
        url: "pmp/zkgl/zkjgListExport",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
//获取成果物列表
export function getCgwList(data) {
    return request({
        url: "pmp/zkgl/getCgwList",
        method: "get",
        params: { ...data, db: dn0 }
    });
}

//复核申请 上传文件操作
export function uploadFile(data) {
    return request({
        url: "pmp/zkgl/zkfhUpload",
        method: "post",
        data
    });
}
// 获取节点审批人
export function getJdspr(data) {
    return request({
        url: "pmp/zkgl/getJdspr",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
// 申请复核保存
export function insertZkfh(data) {
    return request({
        url: "pmp/zkgl/insertZkfh",
        method: "post",
        data: { ...data, db: dn0 }
    });
}

// 复核申请管理列表
export function getFhsqglList(data) {
    return request({
        url: "pmp/zkgl/fhsqglList",
        method: "get",
        params: { ...data, db: dn0 }
    });
}

// 选择指标名称列表
export function getZbmcList(data) {
    return request({
        url: "pmp/zkgl/getZbmcList",
        method: "get",
        params: { db: dn0 }
    });
}
// 报表 指标情况分析
export function getZbqkfxList(data) {
    return request({
        url: "codereq/zkgl_zhbb_zbqkfxList",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
//报表 指标情况分析 合格/不合格列表
export function getXmzlList(data) {
    return request({
        url: "codereq/zkgl_zhbb_zbqkfxxmmx",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
//报表导出
export function zhbbExport(data) {
    return request({
        url: "pmp/zkgl/zhbbExport",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
//各分公司项目总体质量情况
export function getXmztzlqkList(data) {
    return request({
        url: "codereq/zkgl_zhbb_xmztzlqkList",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
//各分公司项目质量明细
export function getXmzlmxList(data) {
    return request({
        url: "codereq/zkgl_zhbb_xmzlmxList",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
//错误数据导出
export function exportErrorList(data) {
    return request({
        url: "zkgl/import/exportErrorList",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
//数据入库
export function importZbjg(data) {
    return request({
        url: "zkgl/import/importZbjg",
        method: "get",
        params: { ...data, db: dn0 }
    });
}


// 复核审批
export function SaveZkfhReview(data) {
    return request({
        url: "pmp/zkgl/zkfhReview",
        method: "get",
        params: { ...data, db: dn0 }
    });
}

// 复核撤销
export function SaveZkfhCancel(data) {
    return request({
        url: "pmp/zkgl/zkfhCancel",
        method: "get",
        params: { ...data, db: dn0 }
    });
}

// 复核退回
export function SaveZkfhReturn(data) {
    return request({
        url: "pmp/zkgl/zkfhReturn",
        method: "get",
        params: { ...data, db: dn0 }
    });
}

// 删除附件材料
export function delZkfhFile(data) {
    return request({
        url: "pmp/zkgl/delZkfhFile",
        method: "get",
        params: { ...data, db: dn0 }
    });
}

// 申请复核修改
export function zkfhUpdate(data) {
    return request({
        url: "pmp/zkgl/zkfhUpdate",
        method: "post",
        data: { ...data, db: dn0 }
    });
}

// 各分公司项目总体质量情况项目数 （弹窗数据）
export function getZtzlxmsList(data) {
    return request({
        url: "codereq/zkgl_zhbb_ztzlqkmx",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
//扣罚标准
export function getKfbzList(data) {
    return request({
        url: "codereq/zkgl_zhbb_zlkftjList",
        method: "get",
        params: { ...data, db: dn0 }
    });
}

// 获取分公司
export function getFgsList(data) {
    return request({
        url: "pmp/zkgl/getFgsList",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
//选择项目_2
export function getXmxxList(data) {
    return request({
        url: "pmp/zkgl/getXmxxList",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
//项目质量分析列表
export function getXmzlfxList(data) {
    return request({
        url: "codereq/zkgl_zhbb_xmzlfxList",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
//复核申请列表文件
export function getFhwjList(data) {
    return request({
        url: "pmp/zkgl/getFhwjList",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
//项目质量分析指标明细
export function getXmzlfxzbmxList(data) {
    return request({
        url: "codereq/zkgl_zhbb_xmzlfxzbmx",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
//质控 查看数据按钮
export function getTsZbDataList(data) {
    return request({
        url: "pmp/zkgl/getTsZbDataList",
        method: "get",
        params: { ...data, db: dn0 }
    });
}
//预警消息推送
export function sendYjMessage(data) {
    return request({
        url: "pmp/zkgl/sendYjMessage",
        method: "get",
        params: { ...data, db: dn0 }
    });
}

// 总体质量指标明细（合格、不合格）
export function getZtzlzbmxList(data) {
    return request({
        url: "codereq/zkgl_zhbb_ztzlzbmx",
        method: "get",
        params: { ...data, db: dn0 }
    });
}

// 项目质量情况指标明细（合格、不合格）
export function getXmzlqkzbmxList(data) {
    return request({
        url: "codereq/zkgl_zhbb_xmzlqkzbmx",
        method: "get",
        params: { ...data, db: dn0 }
    });
}

//指标情况分析
export function getZbqktjList(data) {
    return request({
        url: "codereq/zkgl_zhbb_zbqktj",
        method: "get",
        params: { ...data, db: dn0 }
    });
}


//效果评估咨询人员配置和咨询人员配置两个指标的工作明细数据
export function getRypzZbgzlDataList(data) {
    return request({
        url: "pmp/zkgl/getRypzZbgzlDataList",
        method: "get",
        params: { ...data, db: dn0 }
    });
}

//指标名称列表  动态表头
export function getZbmcDtList(data) {
    return request({
        url: "pmp/zkgl/getZbmcDtList",
        method: "get",
        params: { ...data, db: dn0 }
    });
}

//指标复核审批人编辑
export function editZbgl(data) {
    return request({
        url: "pmp/zkgl/editZbgl",
        method: "get",
        params: { ...data, db: dn0 }
    });
}

/**
 * 指标情况分析 合格、不合格等弹窗数据
 * 合格3，不合格4，未完成2,1未开始，5豁免
 * @param {*} data 
 * @returns 
 */
export function getZbgkfxMxList(data) {
    return request({
        url: "pmp/zkgl/zbqkfxMxList",
        method: "get",
        params: { ...data, db: dn0 }
    });
}

export function getKftjMxList(data) {
    return request({
        url: "pmp/zkgl/kftjMxList",
        method: "get",
        params: { ...data, db: dn0 }
    });
}

